<template>
  <div class="footer">
    <div class="container footer-up">
      <div class="footer-row">
        <!-- TODO -->
        <div class="left">
          <div class="logo-box">
            <img :src="logoBY" width="48" alt="logo" />
            <div class="logo-text-box">
              <span class="logo-text">豹眼背调</span>
              <span class="logo-text-zm">baoyanbd.com</span>
            </div>
          </div>
          <div class="qrcode">
            <img :src="serviceUrl" width="114" height="114" alt="客服微信" v-if="serviceUrl"/>
             <div class="empty-qrcode" v-else></div>
          </div>
          <p class="t-c sub-title">联系客服</p>
        </div>
        <div class="right">
          <div class="footer-cols">
            <div class="footer-col">
              <div class="title">友情链接</div>
              <div class="sub-title">
                <a href="http://www.court.gov.cn/" target="_blank" rel="noopener">最高人民法院</a>
                <a href="http://www.pbccrc.org.cn/" target="_blank" rel="noopener">中国人民银行征信中心</a>
                <a href="http://www.gsxt.gov.cn/index.html" target="_blank" rel="noopener">国家企业信用信息公示系统</a>
                <a href="http://www.mohrss.gov.cn/" target="_blank" rel="noopener">人社局</a>
              </div>
            </div>
            <div class="footer-col">
              <div class="title">快速入口</div>
              <div class="sub-title">
                <router-link to="/industry">场景使用</router-link>
                <router-link to="/service">产品与服务</router-link>
                <router-link to="/about" class="dis-inBlock">了解我们</router-link>
              </div>
            </div>
            <div class="footer-col" style="flex: 2;">
              <div class="title">联系我们</div>
              <div class="sub-title">
                <!-- <p class="to-kefu c-p">在线客服</p> -->
                <!-- <p>邮箱：baoyanbd@163.com</p>
                <p>电话：400-9669-857</p> -->
                <div class="com-box">
                  <p>邮箱：</p>
                  <p>baoyanbd@163.com</p>
                </div>
                <div class="com-box">
                  <p>电话：</p>
                  <p>400-9669-857</p>
                </div>
                <div class="address-box">
                  <p>地址：</p>
                  <p>湖北省武汉东湖新技术开发区光谷大道41号现代·国际设计城三期10号研发楼栋7层01号</p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container footer-bottom-inner">
        <!-- <span>武汉云查信息技术有限公司</span> -->
         <span>Copyright © 武汉云查信息技术有限公司 版权所有</span>
        <span class="beian-label">
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener">
            鄂ICP备2026037097号-1
          </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/api/api';
export default {
  name: 'SiteFooter',
  data() {
    return {
      // logoBY: require('@/assets/images/logo.png'),
      // logo: require('@/assets/images/logo.png'),
      logoBY: require('@/assets/images/logo_yun2.png'),
      // qrcode: require('@/assets/images/kefu_qrcode.jpg')
      serviceUrl: ''
    }
  },
  mounted() {
    this.fetchServiceUrl()
  },
  methods: {
    async fetchServiceUrl() {
      try {
        const response = await api.get('baoyan/customerService/getByServiceType/0', { serialNum: this.serialNum || this.order }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        if (response.code === 200) {
          this.serviceUrl = response.data.serviceUrl || ''
          console.log('serviceUrl', this.serviceUrl)
        } else if (response.code === 500) {
          this.$message({ type: 'error', message: response.msg || '请求出错' })
        }
      } catch (err) {
        // console.log("err2", err)
        this.$message({ type: 'error', message: err.msg || '请求出错' })
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  padding: 64px 0 0;
  background: #092540;
  color: #fff;
}

.footer-up {
  padding-bottom: 62px;
}

.footer-row {
  display: flex;
  align-items: flex-start;
}

.left {
  flex-shrink: 0;
  padding-right: 85px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .qrcode {
    margin: 32px 0 16px;
    border-radius: 4px;
    overflow: hidden;

    .empty-qrcode{
      width: 114px;
      height: 114px;
      background: white;
    }
  }

  .sub-title {
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    line-height: 12px;
  }
}

.right {
  flex: 1;
  max-width: 900px;
}

.footer-cols {
  display: flex;
}

.footer-col {
  flex: 1;
  padding: 0 45px;

  .title {
    margin: 18px 0 40px;
    font-size: 14px;
    font-weight: 600;
    color: #84929f;
    line-height: 14px;
  }

  .sub-title {
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    line-height: 12px;

    >a {
      display: block;
      margin-bottom: 24px;
      color: #fff;

      &:hover {
        color: #84929f;
      }
    }

    >p {
      margin: 0 0 24px;
    }

    a.dis-inBlock {
      margin-right: 24px;
      display: inline-block;
    }
  }

  .to-kefu {
    color: #fff;

    &:hover {
      color: #84929f;
    }
  }
}

.footer-bottom {
  border-top: 1px solid #2d455c;
  padding: 18px 0;
}

.footer-bottom-inner {
  display: flex;
  // justify-content: space-between;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px 16px;
  padding: 0 20px;
  font-size: 12px;
  color: #ccc;
  line-height: 12px;

  .beian-label{
    margin-left: 30%;
  }

  a {
    color: #ccc;

    &:hover {
      color: #fff;
    }
  }
}

@media (max-width: 992px) {
  .footer-row {
    flex-direction: column;
  }

  .left {
    padding-right: 0;
    margin-bottom: 40px;
  }

  .footer-cols {
    flex-direction: column;
  }

  .footer-col {
    padding: 0;
    margin-bottom: 32px;
  }
}


.logo-box {
  display: flex;
  align-items: center;
  justify-content: center;
  // gap: 8px;

  .logo-text-box {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    // align-items: flex-start;

    .logo-text {
      font-size: 18px;
      font-weight: bold;
      color: white;
    }

    .logo-text-zm {
      font-size: 12px;
      color: white;
    }
  }
}

.com-box{
display: flex;
  margin-bottom: 25px;
}

.com-box p:first-child {
  width: 45px;
  flex-shrink: 0;
  margin: 0;
}

.com-box p:last-child {
  flex: 1;
  // line-height: 18px;
  margin: 0;
}

.address-box{
  display: flex;
}

.address-box p:first-child {
  width: 45px;
  flex-shrink: 0;
  margin: 0;
}

.address-box p:last-child {
  flex: 1;
  line-height: 18px;
  margin: 0;
}
</style>
